import React from 'react';

export interface ArribaIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const ArribaIcon: React.FC<ArribaIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m18.334 15.33-6-6-6 6"/>
    </svg>
  );
};

export default ArribaIcon;
